import { formatDate } from '@angular/common';

export const formatBirthday = (dateOfBirthAsUTCISOString, locale) => {
  return formatDate(dateOfBirthAsUTCISOString, 'yyyy-MM-dd', locale, 'UTC');
};
